<template>
  <div class="content">
    <div><span style="margin: 20px;">价格查询</span></div>
    <div style="margin: 20px;">
      <div>
        <el-form
          ref="editModelEvalForm"
          :model="editModelEvalForm"
          :rules="editorFormRules"
          label-width="100px"
          label-position="left"
        >
          <el-form-item label="定价回收商" prop="serviceId">
            <el-select
              clearable
              v-model="editModelEvalForm.serviceId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in queryServiceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类" prop="categoryId">
            <el-select
              clearable
              v-model="editModelEvalForm.categoryId"
              placeholder="请选择"
              @change="getBrandOptions()"
            >
              <el-option
                v-for="item in queryCategoryOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌" prop="brandId">
            <el-select
              clearable
              v-model="editModelEvalForm.brandId"
              placeholder="请选择"
              @change="getModelList()"
            >
              <el-option
                v-for="item in editBrandOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="机型" prop="modelId">
            <el-select
              clearable
              v-model="editModelEvalForm.modelId"
              filterable
              placeholder="请选择"
              @change="getModelEvalParam()"
            >
              <el-option
                v-for="item in editModelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="店员账号">
              <el-input clearable v-model="username" placeholder="请输入店员账号，可选项" style="width:205px"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="24"> <span>物品信息</span>&nbsp;&nbsp; </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row style="border: 1px color black;" v-if="isItemRefresh">
            <el-col :span="24">
              <query-price-option
                v-for="(item, index) in itemValueList"
                :key="index"
                :index="index"
                type="1"
                :eval-value-object="item"
                @getCildrenValue="getCildrenValue"
              ></query-price-option>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="24"> <span>成色信息</span>&nbsp;&nbsp; </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row style="border: 1px color black;" v-if="isConditionRefresh">
            <el-col :span="24">
              <query-price-option
                v-for="(item, index) in conditionValueList"
                :key="index"
                :index="index"
                type="2"
                :eval-value-object="item"
                @getCildrenValue="getCildrenValue"
              ></query-price-option>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="24"> <span>功能信息</span>&nbsp;&nbsp; </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row style="border: 1px color black;" v-if="isFunctionRefresh">
            <el-col :span="24">
              <query-price-option
                v-for="(item, index) in functionValueList"
                :key="index"
                :index="index"
                type="3"
                :eval-value-object="item"
                @getCildrenValue="getCildrenValue"
              ></query-price-option>
            </el-col>
          </el-row>
          <el-divider></el-divider>
        </el-form>
      </div>
      <div>
        <el-button type="primary" @click="submitEditor"
          >查询等级和价格</el-button
        >
      </div>
      <div style="margin-top:20px" v-if="queryResult">
        <div>
          <b>价格：{{ queryResult.price }}</b>
        </div>
        <div style="margin-top:4px">
          等级：{{ queryResult.hjxModelGrade.name }}
          <span style="margin-left:20px"
            >基准价：{{ queryResult.hjxModelPrice.price }}</span
          >
        </div>
        <div style="margin-top:4px">
          扣款项：<span
            v-for="(item, index) in queryResult.hjxModelPriceDeductions"
            :key="index"
            style="margin-right:3px"
            >【{{ item.itemValueName }}{{ item.deduceType==1?(queryResult.hjxModelPrice.price*item.price):item.price }}】</span
          >
        </div>
        <div style="margin-top:4px">价格段预留利润：{{ queryResult.modelProfit||0 }}</div>
        <div style="margin-top:4px">佣金：{{ queryResult.brokerage||0 }}</div>
        <div style="margin-top:4px">店员红包：{{ queryResult.employeeRedPackage||0 }}</div>
        <div style="margin-top:4px">店长红包：{{ queryResult.redPackage||0 }}</div>
        <div style="margin-top:4px">关键人佣金：{{ queryResult.mainPersonCommission||0 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      itemOptionsArray: this.global.itemOptions,
      // 新建编辑对话框数据
      editModelEvalForm: {
        id: null,
        value: null,
        name: null,
        categoryId: null,
        modelId: null,
        serviceId: null,
        brandId: null,
        conditionParam: [],
        functionParam: [],
        modelParam: [],
        userId:null,
      },

      username:'',

      editorFormRules: {
        serviceId: [
          { required: true, message: "请输入定价回收商", trigger: "change" },
        ],
        modelId: [{ required: true, message: "请输入机型", trigger: "change" }],
        brandId: [{ required: true, message: "请选择品牌", trigger: "change" }],
        categoryId: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
      },

      queryCategoryOptions: [],
      editModelList: [],
      editBrandOptions: [],

      itemTemplateValueByBrand: {},

      //物品信息可变框
      itemCheckList: [],
      itemValueList: [],
      isItemRefresh: true,

      //成色信息可变框
      conditionCheckList: [],
      conditionValueList: [],
      isConditionRefresh: true,

      //功能信息可变框
      functionValueList: [],
      isFunctionRefresh: true,
      functionCheckList: [],

      //成色值选项
      conditionValueOptions: [],
      //功能值选项
      functionValueOptions: [],

      //模板ID和模板列表
      functionTempPlateId: null,
      itemTempPlateId: null,
      conditionTempPlateId: null,
      itemTempPlateList: [],
      conditionTempPlateList: [],
      functionTempPlateList: [],

      //根据分类获取不同的参数
      evalModelParam: {},

      queryServiceList: [],

      queryResult: null,
      shopUserList:[]
    };
  },
  watch: {},
  computed: {},
  methods: {
    totalSumAll() {
      let totalSumAll = 0;
      this.queryResult.hjxModelProfits.map((item) => {
        totalSumAll += item.price;
      });
      return totalSumAll;
    },
    //回收商集合
    getServiceList() {
      let self = this;
      this.$api.getValidHjxServiceProvider().then((res) => {
        self.queryServiceList = res.data || [];
      });
    },
    //获取子组件的值
    getCildrenValue(index, type, evalValueObject) {
      if (type === 1) {
        this.itemValueList[index] = evalValueObject;
      } else if (type === 2) {
        this.conditionValueList[index] = evalValueObject;
      } else if (type === 3) {
        this.functionValueList[index] = evalValueObject;
      }
    },
    //根据分类ID，获取等级评估信息
    getModelEvalParam() {
      let self = this;
      self.resetFrom();
      if (
        this.editModelEvalForm.categoryId == null ||
        this.editModelEvalForm.categoryId == "" ||
        this.editModelEvalForm.brandId == null ||
        this.editModelEvalForm.brandId == "" ||
        this.editModelEvalForm.modelId == null ||
        this.editModelEvalForm.modelId == ""
      ) {
        return;
      }
      this.$api
        .priceQueryParam({
          categoryId: this.editModelEvalForm.categoryId,
          brandId: this.editModelEvalForm.brandId,
          modelId: this.editModelEvalForm.modelId,
        })
        .then((res) => {
          self.evalModelParam = res.data || {};
          self.conditionValueOptions = self.evalModelParam.conditionValues;
          self.functionValueOptions = self.evalModelParam.functionValues;
          self.itemTemplateValueByBrand = self.evalModelParam.brandSkuTreeDTO;
          self.itemOptionsArray.forEach((item) => {
            self.showOrHiddenItemValue(item);
          });
          self.conditionValueOptions.forEach((item) => {
            if(item.children!=null&&item.children.length>0){
              item.children.forEach((e) => {
                        e.selected = false;
                      });
              self.showOrHiddenConditionValue(item);
            }
          });
          self.functionValueOptions.forEach((item) => {
              if(item.children!=null&&item.children.length>0){
                item.children.forEach((e) => {
                  e.selected = false;
                });
                self.showOrHiddenFunctionValue(item);
              }
          });
        });
    },

    getBrandOptions() {
      this.resetFrom();
      let categoryId = this.editModelEvalForm.categoryId;
      this.$set(this.editModelEvalForm, "modelId", null);
      this.$set(this.editModelEvalForm, "brandId", null);
      if (categoryId === "") {
        this.$set(this, "editBrandOptions", []);
        this.$set(this, "editModelList", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            categoryId: categoryId,
            typeKey: "phoneBrand",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            self.editBrandOptions = res.data.records || [];
          });
      }
    },

    //机型
    getModelList() {
      this.resetFrom();
      let brandId = this.editModelEvalForm.brandId;
      this.$set(this.editModelEvalForm, "modelId", null);
      if (brandId === "") {
        this.$set(this, "editModelList", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            brandId: brandId,
            typeKey: "phoneModal",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            self.editModelList = res.data.records || [];
          });
      }
    },
    //显示或隐藏成色选项
    showOrHiddenConditionValue(item) {
      let itemTemp = {
        id: null,
        name: null,
        multipleChoice: null,
        children: [],
        selected: false,
      };
      itemTemp.id = item.id;
      itemTemp.name = item.name;
      itemTemp.multipleChoice = item.multipleChoice;
      itemTemp.children = item.children;
      this.conditionValueList.push(itemTemp);
      this.isConditionRefresh = false;
      let self = this;
      this.$nextTick((e) => {
        self.isConditionRefresh = true;
      });
    },
    //显示或隐藏功能选项
    showOrHiddenFunctionValue(item) {
      let itemTemp = {
        id: null,
        name: null,
        multipleChoice: null,
        children: [],
        selected: false,
      };
      itemTemp.id = item.id;
      itemTemp.name = item.name;
      itemTemp.multipleChoice = item.multipleChoice;
      itemTemp.children = item.children;
      this.functionValueList.push(itemTemp);

      this.isFunctionRefresh = false;
      let self = this;
      this.$nextTick((e) => {
        self.isFunctionRefresh = true;
      });
    },
    //显示或隐藏物品选项
    showOrHiddenItemValue(item) {
      let itemTemp = {
        id: null,
        name: null,
        multipleChoice: null,
        children: [],
        selected: false,
      };
      itemTemp.id = item.id;
      itemTemp.name = item.name;
      itemTemp.multipleChoice = 1;
      if(this.itemTemplateValueByBrand === null){
        return
      }else{
        if (item.id === "sku_memory") {
              itemTemp.children = this.itemTemplateValueByBrand.skuMemory;
            } else if (item.id === "sku_purchase_channel") {
              itemTemp.children = this.itemTemplateValueByBrand.skuPurchaseChannel;
            } else if (item.id === "sku_body_color") {
              itemTemp.children = this.itemTemplateValueByBrand.skuBodyColor;
            } else if (item.id === "sku_warranty_duration") {
              itemTemp.children = this.itemTemplateValueByBrand.skuWarrantyDuration;
            } else if (item.id === "sku_small_model") {
              itemTemp.children = this.itemTemplateValueByBrand.skuSmallModel;
            } else if (item.id === "sku_network") {
              itemTemp.children = this.itemTemplateValueByBrand.skuNetwork;
            }else if (item.id === "sku_cpu") {
              itemTemp.children = this.itemTemplateValueByBrand.skuCpu;
            }else if (item.id === "sku_graphics_card") {
              itemTemp.children = this.itemTemplateValueByBrand.skuGraphicsCard;
            }else if (item.id === "sku_solid_drive") {
              itemTemp.children = this.itemTemplateValueByBrand.skuSolidDrive;
            }else if (item.id === "sku_mechanical_drive") {
              itemTemp.children = this.itemTemplateValueByBrand.skuMechanicalDrive;
            }else if (item.id === "sku_charging_interface") {
              itemTemp.children = this.itemTemplateValueByBrand.skuChargingInterface;
            }else if (item.id === "sku_charging_method") {
              itemTemp.children = this.itemTemplateValueByBrand.skuChargingMethod;
            }else if (item.id === "sku_case_size") {
              itemTemp.children = this.itemTemplateValueByBrand.skuCaseSize;
            }else if (item.id === "sku_case_material") {
              itemTemp.children = this.itemTemplateValueByBrand.skuCaseMaterial;
            }else if (item.id === "sku_watch_strap") {
              itemTemp.children = this.itemTemplateValueByBrand.skuWatchStrap;
            }else if (item.id === "sku_strap_color") {
              itemTemp.children = this.itemTemplateValueByBrand.skuStrapColor;
            }else if (item.id === "sku_left_right_ear") {
              itemTemp.children = this.itemTemplateValueByBrand.skuLeftRightEar;
            }else if (item.id === "sku_external_keyboard") {
              itemTemp.children = this.itemTemplateValueByBrand.skuExternalKeyboard;
            }else if (item.id === "sku_accessories_situation") {
              itemTemp.children = this.itemTemplateValueByBrand.skuAccessoriesSituation;
            }
      }
      if(itemTemp.children==null || itemTemp.children.length<=0){
        return
      }
      itemTemp.children.forEach((e) => {
        e.selected = false;
      });
      this.itemValueList.push(itemTemp);
      this.isItemRefresh = false;
      let self = this;
      this.$nextTick((e) => {
        self.isItemRefresh = true;
      });
    },

    //重置表单
    resetFrom() {
      this.conditionValueOptions = [];
      this.functionValueOptions = [];
      this.itemCheckList = [];
      this.functionCheckList = [];
      this.conditionCheckList = [];
      this.itemValueList = [];
      this.conditionValueList = [];
      this.functionValueList = [];
      this.itemTemplateValueByBrand = {};
    },

    // 提交编辑（新建或者修改）
   async submitEditor() {
      let self = this;
      if(self.username!=''){
           await self.getShopUserId().then(res=>{
              if(res==null){
                this.editModelEvalForm.userId = null
                self.$message({
                  message: "找不到该店员",
                  type: "error",
                });
              }else{
                this.editModelEvalForm.userId = res
              }
            })
      }
      if(self.username!=''&& this.editModelEvalForm.userId == null){
         return
      }
      this.$refs["editModelEvalForm"].validate((valid) => {
        if (valid) {
          let params = this.editModelEvalForm;
          this.itemValueList.forEach((item) => {
            if (item.id === "sku_memory") {
              this.itemTemplateValueByBrand.skuMemory = item.children;
            } else if (item.id === "sku_purchase_channel") {
              this.itemTemplateValueByBrand.skuPurchaseChannel = item.children;
            } else if (item.id === "sku_body_color") {
              this.itemTemplateValueByBrand.skuBodyColor = item.children;
            } else if (item.id === "sku_warranty_duration") {
              this.itemTemplateValueByBrand.skuWarrantyDuration = item.children;
            } else if (item.id === "sku_small_model") {
              this.itemTemplateValueByBrand.skuSmallModel = item.children;
            } else if (item.id === "sku_network") {
              this.itemTemplateValueByBrand.skuNetwork = item.children;
            }else if (item.id === "sku_cpu") {
              this.itemTemplateValueByBrand.skuCpu  = item.children;
            }else if (item.id === "sku_graphics_card") {
               this.itemTemplateValueByBrand.skuGraphicsCard  = item.children;
            }else if (item.id === "sku_solid_drive") {
               this.itemTemplateValueByBrand.skuSolidDrive  = item.children;
            }else if (item.id === "sku_mechanical_drive") {
               this.itemTemplateValueByBrand.skuMechanicalDrive  = item.children;
            }else if (item.id === "sku_charging_interface") {
               this.itemTemplateValueByBrand.skuChargingInterface = item.children;
            }else if (item.id === "sku_charging_method") {
              this.itemTemplateValueByBrand.skuChargingMethod = item.children;
            }else if (item.id === "sku_case_size") {
              this.itemTemplateValueByBrand.skuCaseSize = item.children;
            }else if (item.id === "sku_case_material") {
              this.itemTemplateValueByBrand.skuCaseMaterial = item.children;
            }else if (item.id === "sku_watch_strap") {
              this.itemTemplateValueByBrand.skuWatchStrap = item.children;
            }else if (item.id === "sku_strap_color") {
              this.itemTemplateValueByBrand.skuStrapColor = item.children;
            }else if (item.id === "sku_left_right_ear") {
              this.itemTemplateValueByBrand.skuLeftRightEar= item.children;
            }else if (item.id === "sku_external_keyboard") {
              this.itemTemplateValueByBrand.skuExternalKeyboard= item.children;
            }else if (item.id === "sku_accessories_situation") {
              this.itemTemplateValueByBrand.skuAccessoriesSituation= item.children;
            }
          });
          if(this.itemValueList.length>0){
            this.itemTemplateValueByBrand.phoneModel = null;
          }
          params.modelParam = JSON.stringify(this.itemTemplateValueByBrand);
          params.conditionParam = JSON.stringify(this.conditionValueList);
          params.functionParam = JSON.stringify(this.functionValueList);
          self.$api.priceQuery(params).then((res) => {
            if (res.code === 200) {
              self.queryResult = res.data || {};
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    getCategroyOptions() {
      let self = this;
      this.$api
        .getTemplateValue({
          typeKey: "category",
        })
        .then((res) => {
          self.queryCategoryOptions = res.data || [];
        });
    },
    //获取店员ID号
    getShopUserId() {
      let self = this;
      return new Promise((resolve, reject) => {
                this.$api
                  .getUserList({
                    type: 4,
                    status:1,
                    page:1,
                    size:1,
                    username:self.username
                  })
                  .then((res) => {
                    if(res.code==200){
                      self.shopUserList = res.data.records || [];
                      if(self.shopUserList.length>0){
                          resolve(self.shopUserList[0].id) 
                      }
                      resolve(null)
                    }
        });
      })

      
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getCategroyOptions();
    self.getServiceList();
  },
};
</script>
<style lang="less" scoped>
.content {
  background-color: white;
  padding: 20px;
}
</style>
